export default __webpack_public_path__ + "static/media/onboarding_home.c1e89a35.svg";